<template>
    <div>
        <div class="modal fade" tabindex="-1" id="ModalMatrizRiscos">
            <div class="modal-dialog modal-dialog-centered modal-xxl">
                <div class="modal-content border-0 modal-matriz-content">
                    <div class="modal-body p-0">
                        <div class="py-4 px-4">
                            <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <h3 class="title m-0 d-flex align-items-center gap-2">
                                    <i class="fas fa-project-diagram"></i>
                                    Mapa de Risco
                                </h3>
                                <div class="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                    <button class="btn btn-success" @click="gerarIA">
                                        Verificar riscos com IA
                                    </button>
                                    <button class="btn btn-outline-success"
                                            @click="vincularMatrizProcesso"
                                            v-if="!nenhumRiscoDisponivel"
                                            title="Vincular mapa ao processo">
                                        <i class="fas fa-link me-2"></i>
                                        Utilizar Mapa no Processo
                                    </button>
                                </div>
                            </div>
                            <hr />
                            <div class="card-matriz shadow-sm">
                                <!-- NAV TABS -->
                                <ul class="nav nav-tabs mb-0" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: abaAtiva === 'diretrizes' }" @click="abaAtiva = 'diretrizes'" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard2-data me-1" viewBox="0 0 16 16">
                                        <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
                                        <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
                                        <path d="M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1" />
                                    </svg>
                                    Diretrizes de Risco
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: abaAtiva === 'registro' }" @click="abaAtiva = 'registro'" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard2-pulse me-1" viewBox="0 0 16 16">
                                        <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
                                        <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
                                        <path d="M9.979 5.356a.5.5 0 0 0-.968.04L7.92 10.49l-.94-3.135a.5.5 0 0 0-.926-.08L4.69 10H4.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 .447-.276l.936-1.873 1.138 3.793a.5.5 0 0 0 .968-.04L9.58 7.51l.94 3.135A.5.5 0 0 0 11 11h.5a.5.5 0 0 0 0-1h-.128z" />
                                    </svg>
                                    Registro de Risco
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: abaAtiva === 'planos' }" @click="abaAtiva = 'planos'" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard2-plus me-1" viewBox="0 0 16 16">
                                        <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
                                        <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
                                        <path d="M8.5 6.5a.5.5 0 0 0-1 0V8H6a.5.5 0 0 0 0 1h1.5v1.5a.5.5 0 0 0 1 0V9H10a.5.5 0 0 0 0-1H8.5z" />
                                    </svg>
                                    Planos de Ação
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" :class="{ active: abaAtiva === 'mapa' }" @click="abaAtiva = 'mapa'" type="button">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3-gap-fill me-1" viewBox="0 0 16 16">
                                        <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z" />
                                    </svg>
                                    Mapa de Risco
                                </button>
                            </li>
                        </ul>

                        <!-- ABAS -->
                        <div>
                            <div v-if="abaAtiva === 'diretrizes'">
                                <div class="accordion" id="accordionDiretrizes">
                                    <!-- Etapa 1 -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="etapa1Header">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#etapa1" aria-expanded="true" aria-controls="etapa1">
                                                Etapa 1 - Identificação dos Riscos
                                            </button>
                                        </h2>
                                        <div id="etapa1" class="accordion-collapse collapse show" aria-labelledby="etapa1Header">
                                            <div class="accordion-body">
                                                <div class="table-wrapper">
                                                    <table class="custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">ITEM DA COLUNA</th>
                                                                <th>DESCRIÇÃO</th>
                                                                <th>REFERÊNCIA</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center">ID dos Riscos</td>
                                                                <td>Número de identificação do risco</td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Risco</td>
                                                                <td>Evento que existe a probabilidade de acontecer e gerar determinado impacto que cause prejuízos às atividades e objetivos da Empresa</td>
                                                                <td>Perda dos dados da Empresa</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Causas do Risco</td>
                                                                <td>Causas que podem provocar o risco</td>
                                                                <td>Servidor de dados antigo, sem a realização de backups</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Consêquencia</td>
                                                                <td>Descrição dos principais impactos ocasionados caso haja a materialização do risco. Serve de suporte para entender a graduação do impacto indicada pela equipe.</td>
                                                                <td>Não conclusão de eventos, impossibilidade de prestação de contas da Empresa, não recuperação de dados históricos das atividades de suporte e administrativas da Empresa</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Resposta ao Risco</td>
                                                                <td>Refere-se à resposta da Empresa para cada risco identificado.</td>
                                                                <td>As respostas aos riscos podem ser: a) Aceitar; b) Mitigar; c) Transferir; d) Evitar.</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Etapa 2 -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="etapa2Header">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#etapa2" aria-expanded="false" aria-controls="etapa2">
                                                Etapa 2 - Avaliação do Risco
                                            </button>
                                        </h2>
                                        <div id="etapa2" class="accordion-collapse collapse" aria-labelledby="etapa2Header">
                                            <div class="accordion-body">
                                                <!-- Escala de Probabilidade -->
                                                <h5 class="mt-4">Escala de Probabilidade</h5>
                                                <div class="table-wrapper">
                                                    <table class="custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">Nível</th>
                                                                <th>Probabilidade</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="nivel in 5" :key="'prob' + nivel">
                                                                <td class="text-center"
                                                                    style="width: 10%"
                                                                    :style="{ backgroundColor: getCorPorNivel(nivel) }">
                                                                    {{ getNivelTexto(nivel) }}
                                                                </td>

                                                                <td>
                                                                    {{ getDescricaoPorNivel(escalas.probabilidade, nivel, 'dsProbablidades') }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <!-- Escala Qualitativa -->
                                                <h5 class="mt-5">Escala de Impacto Qualitativo</h5>
                                                <div class="table-wrapper">
                                                    <table class="custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">Nível</th>
                                                                <th>Impacto</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="nivel in 5" :key="'qual' + nivel">
                                                                <td class="text-center"
                                                                    style="width: 10%"
                                                                    :style="{ backgroundColor: getCorPorNivel(nivel) }">
                                                                    {{ getNivelTexto(nivel) }}
                                                                </td>

                                                                <td>
                                                                    {{ getDescricaoPorNivel(escalas.qualitativa, nivel, 'dsImpacto') }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <!-- Escala Quantitativa -->
                                                <h5 class="mt-5">Escala de Impacto Quantitativo</h5>
                                                <div class="table-wrapper">
                                                    <table class="custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">Nível</th>
                                                                <th>Impacto</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="nivel in 5" :key="'quan' + nivel">
                                                                <td class="text-center"
                                                                    style="width: 10%"
                                                                    :style="{ backgroundColor: getCorPorNivel(nivel) }">
                                                                    {{ getNivelTexto(nivel) }}
                                                                </td>

                                                                <td>
                                                                    {{ getDescricaoPorNivel(escalas.quantitativa, nivel, 'dsImpacto') }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Etapa 3 -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="etapa3Header">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#etapa3" aria-expanded="false" aria-controls="etapa3">
                                                Etapa 3 - Resposta ao Risco
                                            </button>
                                        </h2>
                                        <div id="etapa3" class="accordion-collapse collapse" aria-labelledby="etapa3Header">
                                            <div class="accordion-body">
                                                <div class="table-wrapper">
                                                    <table class="custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">RESPOSTA</th>
                                                                <th>DESCRIÇÃO</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center">Aceitar</td>
                                                                <td>
                                                                    Os riscos retidos devem ser apenas monitorados a fim de que se identifique eventual aumento de sua probabilidade e impacto,
                                                                    uma vez que seus prejuízos são irrelevantes diante do contexto da Empresa.
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Mitigar</td>
                                                                <td>
                                                                    Os riscos mitigados são aqueles em que serão tomadas providências para a diminuição da probabilidade de ocorrência dos seus impactos.
                                                                    Diferente do risco a ser evitado, a mitigação visa a diminuição da probabilidade em nível aceitável ao apetite de risco da Empresa
                                                                    enquanto aquele visa a eliminação da causa-raiz.
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Transferir</td>
                                                                <td>
                                                                    Os riscos transferidos são aqueles em que a responsabilidade pelo seu gerenciamento são conferidos a outra parte da relação ou a terceiro,
                                                                    ou seja, não há a criação de plano de ação que diminua ou elimine a probabilidade da ocorrência dos seus impactos, mas sim sua transferência.
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Evitar</td>
                                                                <td>
                                                                    O risco é evitado, ou prevenido, quando o impacto dele é tão representativo à organização que se faz necessário a eliminação
                                                                    de sua causa-raiz de modo que sua probabilidade chegue a quase zero.
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Etapa 4 -->
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="etapa4Header">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#etapa4" aria-expanded="false" aria-controls="etapa4">
                                                Etapa 4 - Planos de Ação
                                            </button>
                                        </h2>
                                        <div id="etapa4" class="accordion-collapse collapse" aria-labelledby="etapa4Header">
                                            <div class="accordion-body">
                                                <div class="table-wrapper">
                                                    <table class="custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center">ITEM DA COLUNA</th>
                                                                <th>DESCRIÇÃO</th>
                                                                <th>EXPLICAÇÃO</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center">Plano de Ação</td>
                                                                <td>Plano elaborado pela área para mitigar o risco. Pode ser, por exemplo, um projeto em andamento ou uma ação ainda não iniciada. Todo risco precisa de um plano de ação.</td>
                                                                <td>Um plano de ação é o desenvolvimento de uma atividade, processo, contratações, que visam diminuir a exposição da Empresa ao risco.</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Responsáveis</td>
                                                                <td>Refere-se ao gestor responsável pelo plano de ação. Normalmente é o risk owner do mapa, mas pode ter mais de um gestor se tratar-se de um plano de ação compartilhado.</td>
                                                                <td>Nome do responsável no âmbito da Empresa.</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Data Início/Data Final</td>
                                                                <td>Datas definidas de início e fim do plano de ação.</td>
                                                                <td>Riscos com níveis mais altos de probabilidade e impacto podem possuir uma data de início e fim mais curtas para implementação do plano de ação do que riscos com nível menor.</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Status do Plano de Ação</td>
                                                                <td>Andamento do Plano de Ação</td>
                                                                <td>Os status do plano de ação são indicados no mapa de riscos e podem ser: Não elaborado, Não iniciado, Em Andamento, Finalizado.</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Força do Plano de Ação</td>
                                                                <td>Análise de quanto o plano de ação, após a implementação dos controles, mitiga o risco</td>
                                                                <td>A força do plano de ação visa avaliar qual a força dos controles internos e planos de ação nos processos da empresa, após implementados e com determinado tempo de maturação.</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center">Resultado do Plano de Ação</td>
                                                                <td>Após a implementação do plano de ação, a análise se ele foi efetivo para mitigar o risco</td>
                                                                <td>O plano de ação pode ser considerado efetivo ou não efetivo.</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="abaAtiva === 'registro'">
                                <div class="d-flex justify-content-end mb-1">
                                    <button class="btn btn-success" @click="novoRisco">
                                        Novo Risco
                                    </button>
                                </div>
                                <div class="table-wrapper mb-3">
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th class="text-center">Código</th>
                                                <th>Título</th>
                                                <th>Descrição</th>
                                                <th class="text-center" style="width: 1%">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(registro, index) in registroRiscos" :key="index">
                                                <td class="text-center">{{ registro.risco.cdRisco }}</td>
                                                <td>{{ registro.risco.dsTitulo }}</td>
                                                <td>{{ registro.risco.dsRisco }}</td>
                                                <td data-label="Ações" class="text-center" style="white-space: nowrap">
                                                    <button @click="editarRisco(registro.risco)"
                                                            class="btn btn-outline-primary me-2"
                                                            title="Editar Risco">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                        </svg>
                                                        Editar
                                                    </button>
                                                    <button @click="excluirRisco(registro.risco.idRisco)"
                                                            class="btn btn-outline-danger"
                                                            title="Excluir Risco">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="registroRiscos.length === 0">
                                                <td colspan="4" class="text-center">Nenhum risco registrado.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div v-if="abaAtiva === 'planos'">
                                <div class="d-flex justify-content-end mb-1">
                                    <button class="btn btn-success" @click="novoPlano">
                                        Novo Plano de Ação
                                    </button>
                                </div>
                                <div class="table-wrapper mb-3">
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th class="text-center">Código</th>
                                                <th>Título</th>
                                                <th>Descrição</th>
                                                <th class="text-center" style="width: 1%">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(registro, index) in registroPlanos" :key="index">
                                                <td class="text-center">{{ registro.planoAcao.cdPlanoAcao }}</td>
                                                <td>{{ registro.planoAcao.dsTitulo }}</td>
                                                <td>{{ registro.planoAcao.dsPlanoAcao }}</td>
                                                <td data-label="Ações" class="text-center" style="white-space: nowrap">
                                                    <button @click="editarPlano(registro.planoAcao)"
                                                            class="btn btn-outline-primary me-2"
                                                            title="Editar Plano">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                        </svg>
                                                        Editar
                                                    </button>
                                                    <button @click="excluirPlano(registro.planoAcao.idPlanoAcao)"
                                                            class="btn btn-outline-danger"
                                                            title="Excluir Plano">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="registroPlanos.length === 0">
                                                <td colspan="4" class="text-center">Nenhum plano de ação registrado.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div v-if="abaAtiva === 'mapa'">
                                <MatrizRisco :idProcesso="idProcesso" :idProcessoModeloArtefato="idProcessoModeloArtefato" :refresh="refreshMatriz"></MatrizRisco>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <ModalRiscos v-if="registroRiscoSelecionado"
                     ref="modalRiscos"
                     :risco="registroRiscoSelecionado"
                     :idMatriz="form.idMatriz"
                     @fechado="aoFecharModalRisco" />
        <ModalPlanos v-if="registroPlanoSelecionado"
                     ref="modalPlano"
                     :planoAcao="registroPlanoSelecionado"
                     :idMatriz="form.idMatriz"
                     @fechado="aoFecharModalPlano" />
    </div>
</template>


<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import ModalRiscos from '@/components/ModalMatrizRiscos/ModalRiscos.vue'
    import ModalPlanos from '@/components/ModalMatrizRiscos/ModalPlanos.vue'
    import MatrizRisco from '@/components/ModalMatrizRiscos/MatrizRisco'
    import axios from 'axios'
    import Swal from 'sweetalert2'

    export default {
        components: { ModalRiscos, MatrizRisco, ModalPlanos },
        props: {
            idProcesso: String,
            idProcessoModeloArtefato: String,
            dsNome: String,
        },
        data() {
            return {
                abaAtiva: 'diretrizes',
                precisaReabrir: false,
                form: {
                    idMatriz: '',
                    cdMatriz: '',
                    nmMatriz: '',
                    dsMatriz: '',
                    idProcesso: null,
                    idProcessoModeloArtefato: null,
                    dsNome: null,
                },
                escalas: {
                    qualitativa: [],
                    quantitativa: [],
                    probabilidade: []
                },
                registroRiscos: [],
                registroRiscoSelecionado: null,
                registroPlanos: [],
                registroPlanoSelecionado: null,

                refreshMatriz: false,

            };
        },

        watch: {
            dsNome: {
                immediate: true,
                handler(novoValor) {
                    this.form.dsNome = novoValor;
                }
            }
        },
        computed: {
            nenhumRiscoDisponivel() {
                return this.registroRiscos.length === 0;
            }
        },
        methods: {
            
            load() {
                axios.get(`${urlApi}/GerenciamentoMatrizRisco/GetByProcesso/${this.idProcesso}`)
                    .then(res => {
                        if (res.data.success && res.data.data && res.data.data.matriz) {
                            const m = res.data.data.matriz;
                            this.form.idMatriz = m.idMatriz || '';
                            this.form.cdMatriz = m.cdMatriz || '';
                            this.form.nmMatriz = m.nmMatriz || '';
                            this.form.dsMatriz = m.dsMatriz || '';
                            this.form.idProcesso = m.idProcesso ?? this.form.idProcesso;
                            this.form.idProcessoModeloArtefato = m.idProcessoModeloArtefato ?? this.form.idProcessoModeloArtefato;
                            this.getEscalas(m.idMatriz);
                            this.carregarRegistroRiscos(m.idMatriz);
                            this.carregarRegistroPlanos(m.idMatriz);
                        } else {
                            this.form.cdMatriz = '';
                            this.form.nmMatriz = '';
                            this.form.dsMatriz = '';
                        }
                    })
                    .catch(() => {
                        this.form.cdMatriz = '';
                        this.form.nmMatriz = '';
                        this.form.dsMatriz = '';
                        avisoErro("Erro ao carregar mapa existente.");
                    });
            },

            abrir(aba = 'diretrizes') {
                this.abaAtiva = ''; 

                this.form.idProcesso = parseInt(this.idProcesso);
                this.form.idProcessoModeloArtefato = parseInt(this.idProcessoModeloArtefato);

                axios.get(`${urlApi}/GerenciamentoMatrizRisco/GetByProcesso/${this.idProcesso}`)
                    .then(res => {
                        const data = res.data?.data;
                        const matriz = data?.matriz;

                        if (res.data.success && matriz) {
                            this.preencherForm(matriz);
                            this.getEscalas(matriz.idMatriz).then(() => {
                                this.carregarRegistroRiscos(matriz.idMatriz);
                                this.carregarRegistroPlanos(matriz.idMatriz);
                                this.abaAtiva = aba;
                            });
                        } else {
                            const nomeProcesso = this.form.dsNome || 'Processo Sem Nome';
                            const payload = {
                                idProcesso: this.form.idProcesso,
                                idProcessoModeloArtefato: this.form.idProcessoModeloArtefato,
                                cdMatriz: `MTR-${this.idProcesso}`,
                                nmMatriz: `Mapa de risco do processo: ${nomeProcesso}`,
                                dsMatriz: ''
                            };

                            axios.post(`${urlApi}/GerenciamentoMatrizRisco/Post`, payload)
                                .then(resp => {
                                    if (resp.data.success) {
                                        avisoToast('Mapa criado automaticamente.');

                                        this.precisaReabrir = true;
                                        if (this.modalInstance) {
                                            this.modalInstance.hide();
                                        }
                                    } else {
                                        avisoErro("Erro ao criar novo mapa.");
                                    }
                                })
                                .catch(() => avisoErro("Erro ao criar novo mapa."));
                        }
                    })
                    .catch(() => avisoErro("Erro ao buscar mapa existente."));

                this.modalInstance = new window.bootstrap.Modal(document.getElementById('ModalMatrizRiscos'));
                this.modalInstance.show();

                const modalEl = document.getElementById('ModalMatrizRiscos');
                if (modalEl) {
                    modalEl.addEventListener('hidden.bs.modal', () => {
                        if (this.precisaReabrir) {
                            this.precisaReabrir = false;
                           
                            this.$nextTick(() => {
                                this.abrir(aba); 
                            });
                        } else {
                            this.$emit('fechado');
                        }
                    }, { once: true });
                }
            },

            preencherForm(m) {
                this.form.idMatriz = m.idMatriz || '';
                this.form.cdMatriz = m.cdMatriz || '';
                this.form.nmMatriz = m.nmMatriz || '';
                this.form.dsMatriz = m.dsMatriz || '';
                this.form.idProcesso = m.idProcesso ?? this.form.idProcesso;
                this.form.idProcessoModeloArtefato = m.idProcessoModeloArtefato ?? this.form.idProcessoModeloArtefato;
            },

            getEscalas(idMatriz) {
                return axios.get(`${urlApi}/GerenciamentoMatrizRisco/GetEscalas`, { params: { idMatriz } })
                    .then(res => {
                        if (res.data) {
                            const normalizar = (rows, prop) => ({
                                rows: (rows?.rows || []).map(r => r[prop]),
                                qtdRecords: rows?.qtdRecords || 0
                            });

                            this.escalas.qualitativa = normalizar(res.data.escalaAnaliseQualitativa, 'analiseQualitativa');
                            this.escalas.quantitativa = normalizar(res.data.escalaAnaliseQuantitativa, 'analiseQuantitativa');
                            this.escalas.probabilidade = normalizar(res.data.escalaProbabilidade, 'escalaProbabilidade');
                        } else {
                            avisoErro("Não foi possível carregar as escalas.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar escalas.");
                    });
            },

            getNivelTexto(nivel) {
                const niveis = {
                    1: 'Muito Alto',
                    2: 'Alto',
                    3: 'Moderado',
                    4: 'Baixo',
                    5: 'Muito Baixo'
                };
                return niveis[nivel] || '';
            },

            getCorPorNivel(nivel) {
                const cores = {
                    1: '#E8B6C1', // Muito Alto
                    2: '#E1BEAB', // Alto
                    3: '#E7DD96', // Moderado
                    4: '#BBE3C1', // Baixo
                    5: '#B6DBE8'  // Muito Baixo 
                };
                return cores[nivel] || '#ffffff'; 
            },

            getDescricaoPorNivel(lista, nivelDesejado, campo) {
                return lista.rows?.find(e => e.idEscala === nivelDesejado)?.[campo] || '—';
            },

            carregarRegistroRiscos(idMatriz) {
                axios.get(`${urlApi}/GerenciamentoRisco/Get`, {
                    params: {
                        idMatriz: idMatriz
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.registroRiscos = res.data.data?.rows || [];
                        } else {
                            avisoErro("Erro ao buscar registro de riscos.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição dos riscos.");
                    });
            },

            editarRisco(risco) {
                this.registroRiscoSelecionado = risco;       
                this.modalInstance.hide();               

                this.$nextTick(() => {
                    const modalEl = document.getElementById('ModalRisco');
                    if (modalEl) {
                        const modal = new window.bootstrap.Modal(modalEl);
                        modal.show();

                        modalEl.addEventListener('hidden.bs.modal', () => {
                            this.registroRiscoSelecionado = null;
                            this.modalInstance.show();       
                        }, { once: true });
                    }
                });
            },

            novoRisco() {
                this.registroRiscoSelecionado = {};
                this.modalInstance.hide(); 

                this.$nextTick(() => {
                    const modalEl = document.getElementById('ModalRisco');
                    if (modalEl) {
                        const modal = new window.bootstrap.Modal(modalEl);
                        modal.show();

                        modalEl.addEventListener('hidden.bs.modal', () => {
                            this.registroRiscoSelecionado = null;
                            this.modalInstance.show();
                        }, { once: true });
                    }
                });
            },

            carregarRegistroPlanos(idMatriz) {
                axios.get(`${urlApi}/GerenciamentoPlanoAcao/Get`, {
                    params: {
                        idMatriz: idMatriz
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            this.registroPlanos = res.data.data?.rows || [];
                        } else {
                            avisoErro("Erro ao buscar registro de riscos.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição dos riscos.");
                    });
            },

            editarPlano(planoAcao) {
                this.registroPlanoSelecionado = planoAcao;
                this.modalInstance.hide();

                this.$nextTick(() => {
                    const modalEl = document.getElementById('ModalPlano');
                    if (modalEl) {
                        const modal = new window.bootstrap.Modal(modalEl);
                        modal.show();

                        modalEl.addEventListener('hidden.bs.modal', () => {
                            this.registroPlanoSelecionado = null;
                            this.modalInstance.show();
                        }, { once: true });
                    }
                });
            },

            novoPlano() {
                this.registroPlanoSelecionado = {};
                this.modalInstance.hide();

                this.$nextTick(() => {
                    const modalEl = document.getElementById('ModalPlano');
                    if (modalEl) {
                        const modal = new window.bootstrap.Modal(modalEl);
                        modal.show();

                        modalEl.addEventListener('hidden.bs.modal', () => {
                            this.registroPlanoSelecionado = null;
                            this.modalInstance.show();
                        }, { once: true });
                    }
                });
            },

            aoFecharModalPlano() {
                this.registroPlanoSelecionado = null;
                this.abrir('planos'); 
            },

            aoFecharModalRisco() {
                this.registroRiscoSelecionado = null;
                this.abrir('registro'); 
            },

            excluirRisco(idRisco) {
                Swal.fire({
                    title: 'Excluir Risco?',
                    text: 'Essa ação removerá o risco, suas causas/consequências e vínculos com planos de ação.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#2563EB',
                    confirmButtonText: 'Sim, excluir',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/GerenciamentoRisco/Delete`, { idRisco })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Risco excluído com sucesso!", "success");
                                    this.carregarRegistroRiscos(this.form.idMatriz);
                                } else {
                                    avisoErro(res.data.msg || "Erro ao excluir risco.");
                                }
                            })
                            .catch(() => {
                                avisoErro("Erro na requisição de exclusão do risco.");
                            });
                    }
                });
            },

            VerificaArtefatos() {
                return axios.get(`${urlApi}/ProcessoArtefato/GetArtefatos`, {
                    params: {
                        idProcesso: this.idProcesso
                    }
                })
                    .then(res => {
                        if (!res.data.success || !res.data.data) {
                            avisoErro("Erro ao buscar os artefatos do processo.");
                            return false;
                        }

                        const artefatos = res.data.data || [];
                        if (artefatos.length === 0) {
                            avisoErro("Para realizar a geração por IA, é necessário o upload dos documentos DFD e ETP nos artefatos do processo.");
                            return false;
                        }

                        const temDFD = artefatos.some(a => a.idProcessoModeloArtefato === 1);
                        //const temETP = artefatos.some(a => a.idProcessoModeloArtefato === 2);
                        const temETP = true;

                        if (!temDFD || !temETP) {
                            let faltando = [];
                            if (!temDFD) faltando.push("DFD");
                            if (!temETP) faltando.push("ETP");

                            avisoErro(`Ainda faltam os seguintes documentos para permitir a geração por IA: ${faltando.join(" e ")}.`);
                            return false;
                        }

                        return true;
                    })
                    .catch(() => {
                        avisoErro("Erro na requisição de verificação de artefatos.");
                        return false;
                    });
            },

            async gerarIA() {
                const podeGerar = await this.VerificaArtefatos();
                if (!podeGerar) return;

                Swal.fire({
                    title: 'Confirmar geração por IA',
                    html: `
            Esta ação utilizará inteligência artificial para gerar automaticamente novos riscos e planos de ação de acordo com os artefatos enviados.<br><br>
            <strong>Atenção:</strong> riscos e planos já existentes <u>não serão considerados</u> pelo modelo, o que pode resultar em conteúdos semelhantes ou duplicados.<br><br>
            Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1f7bff',
                    cancelButtonColor: '#6E7881',
                    confirmButtonText: 'Sim, gerar por IA',
                    cancelButtonText: 'Cancelar'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/GerenciamentoRisco/GerarIA`, this.form)
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Riscos e planos gerados com sucesso.");
                                    this.refreshMatriz = !this.refreshMatriz;
                                    this.load();
                                } else {
                                    avisoErro("Erro ao gerar: " + (res.data.msg || "Erro inesperado."));
                                }
                            })
                            .catch(err => {
                                if (err.response && err.response.data) {
                                    const msg = err.response.data.msg;
                                    const extra = err.response.data.errors?.[0] || '';
                                    avisoErro(`${msg} ${extra}`);
                                } else {
                                    avisoErro("Erro ao gerar os dados por IA.");
                                }
                            });
                    }
                });
            },

            excluirPlano(idPlanoAcao) {
                Swal.fire({
                    title: 'Excluir Plano de Ação?',
                    text: 'Essa ação removerá o plano e todos os vínculos com riscos.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#2563EB',
                    confirmButtonText: 'Sim, excluir',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/GerenciamentoPlanoAcao/Delete`, { idPlanoAcao })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Plano de ação excluído com sucesso!", "success");
                                    this.carregarRegistroPlanos(this.form.idMatriz);
                                } else {
                                    avisoErro(res.data.msg || "Erro ao excluir plano.");
                                }
                            })
                            .catch(() => {
                                avisoErro("Erro na requisição de exclusão do plano.");
                            });
                    }
                });
            },

            vincularMatrizProcesso() {
                Swal.fire({
                    title: 'Vincular Mapa de Risco?',
                    html: `Antes de prosseguir, <strong>recomendamos que você acesse a aba "Mapa de Risco"</strong> e revise se todos os riscos e planos estão corretamente configurados.<br><br>
                           Essa ação vinculará o mapa ao processo.<br><br>
                           Deseja continuar?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2563EB',
                    cancelButtonColor: '#6E7881',
                    confirmButtonText: 'Sim, vincular',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/GerenciamentoRisco/VincularMatrizProcesso`, {
                            idProcesso: this.idProcesso,
                            idProcessoModeloArtefato: this.idProcessoModeloArtefato
                        })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Mapa vinculada com sucesso.");
                                    this.$store.commit('setReload');
                                } else {
                                    avisoErro("Erro ao salvar: " + (res.data.msg || "Erro inesperado."));
                                }
                            })
                            .catch(err => {
                                if (err.response && err.response.data) {
                                    const msg = err.response.data.msg;
                                    const extra = err.response.data.errors?.[0] || '';
                                    avisoErro(`${msg} ${extra}`);
                                } else {
                                    avisoErro("Erro ao salvar a mapa.");
                                }
                            });
                    }
                });
            },
        },
    }
</script>
<style lang="scss" scoped>
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(16px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .modal-xxl {
        width: calc(100vw - 50px);
        max-width: calc(100vw - 50px);
        height: calc(100vh - 50px);
        margin: 25px;

        .modal-content {
            height: 100%;
            max-height: calc(100vh - 50px);
        }

        .modal-body {
            overflow-y: auto;
            max-height: calc(100vh - 50px);
            padding: 0;
            /* Custom Scrollbar */
            &::-webkit-scrollbar {
                width: 10px;
            }

            &::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 10px;
                margin: 10px 0;
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                border-radius: 10px;

                &:hover {
                    background: linear-gradient(135deg, #0056d2 0%, #00a065 100%);
                }
            }
        }

        @media (max-width: 768px) {
            width: calc(100vw - 20px);
            max-width: calc(100vw - 20px);
            height: calc(100vh - 20px);
            margin: 10px;

            .modal-content {
                max-height: calc(100vh - 20px);
            }

            .modal-body {
                max-height: calc(100vh - 20px);

                &::-webkit-scrollbar {
                    width: 6px;
                }
            }
        }
    }

    .modal-matriz-content {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    }

    .title {
        font-size: 2rem;
        font-weight: 700;
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        letter-spacing: -0.25px;

        i {
            font-size: 1.6rem;
            background: inherit;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            filter: drop-shadow(0 4px 18px rgba(37, 99, 235, 0.35));
        }

        @media (max-width: 768px) {
            font-size: 1.6rem;
        }
    }

    hr {
        border: 0;
        height: 2px;
        background: linear-gradient(90deg, rgba(37, 99, 235, 0), rgba(37, 99, 235, 0.35), rgba(37, 99, 235, 0));
        margin: 1.25rem 0 1.5rem;
    }

    .card-matriz {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.92) 0%, rgba(248, 250, 252, 0.95) 100%);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 20px;
        padding: 1.75rem;
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
        display: flex;
        flex-direction: column;
        gap: 1.75rem;
    }

    .card-matriz > .nav-tabs {
        margin: -1.75rem -1.75rem 0;
        padding: 1.25rem 1.75rem 0.5rem;
        border-bottom: 1px solid rgba(226, 232, 240, 0.7);
        background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(237, 242, 247, 0.9) 100%);
        border-radius: 20px 20px 0 0;
        position: sticky;
        top: 0;
        z-index: 2;
    }

    .nav-tabs {
        display: flex;
        gap: 0.5rem;
        border-bottom: none;
        flex-wrap: wrap;
    }

    .nav-tabs .nav-link {
        border: 1px solid transparent;
        background: rgba(248, 250, 252, 0.65);
        color: #475569;
        font-weight: 600;
        padding: 0.65rem 1.25rem;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        transition: all 0.2s ease;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.6);
    }

    .nav-tabs .nav-link svg {
        width: 18px;
        height: 18px;
    }

    .nav-tabs .nav-link:hover {
        background: rgba(37, 99, 235, 0.08);
        color: #2563EB;
        box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.25);
    }

    .nav-tabs .nav-link.active {
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        color: #ffffff;
        box-shadow: 0 10px 24px rgba(37, 99, 235, 0.25);
    }

    .nav-tabs .nav-link.active svg {
        fill: currentColor;
    }

    .btn {
        border-radius: 12px;
        font-weight: 600;
        padding: 0.65rem 1.35rem;
        border: none;
        transition: all 0.25s ease;
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
        box-shadow: 0 6px 18px rgba(15, 118, 110, 0.15);
    }

    .btn i {
        font-size: 1rem;
    }

    .btn-success {
        background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
        color: #ffffff;
    }

    .btn-success:hover {
        background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
        transform: translateY(-1px);
        box-shadow: 0 12px 28px rgba(34, 197, 94, 0.35);
    }

    .btn-outline-success {
        background: transparent;
        border: 2px solid rgba(34, 197, 94, 0.65);
        color: #15803d;
        box-shadow: none;
    }

    .btn-outline-success:hover {
        background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(34, 197, 94, 0.2) 100%);
        color: #15803d;
    }

    .btn-outline-primary,
    .btn-outline-danger {
        border-radius: 10px;
        padding: 0.5rem 0.95rem;
        height: 38px;
        min-width: 110px;
        justify-content: center;
        box-shadow: none;
    }

    .btn-outline-primary {
        border: 1px solid rgba(37, 99, 235, 0.45);
        color: #2563EB;
        background: rgba(37, 99, 235, 0.08);
    }

    .btn-outline-primary:hover {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.18) 0%, rgba(37, 99, 235, 0.28) 100%);
        color: #1d4ed8;
    }

    .btn-outline-danger {
        border: 1px solid rgba(239, 68, 68, 0.45);
        color: #dc2626;
        background: rgba(239, 68, 68, 0.08);
    }

    .btn-outline-danger:hover {
        background: linear-gradient(135deg, rgba(239, 68, 68, 0.18) 0%, rgba(239, 68, 68, 0.24) 100%);
        color: #b91c1c;
    }

    .table-wrapper {
        width: 100%;
        padding: 0;
        margin: 0 auto;
        overflow-x: auto;
        border-radius: 14px;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.7);
        max-height: none !important;
    }

    .custom-table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
        overflow: hidden;
        background-color: rgba(255, 255, 255, 0.92);
    }

    .custom-table thead {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(34, 197, 94, 0.12) 100%);
    }

    .custom-table th,
    .custom-table td {
        padding: 0.9rem 1.2rem;
        text-align: left;
        border-bottom: 1px solid rgba(226, 232, 240, 0.7);
        font-size: 0.95rem;
        color: #0f172a;
    }

    .custom-table tbody tr:hover {
        background: rgba(37, 99, 235, 0.06);
    }

    .accordion-item {
        border-radius: 16px;
        margin-bottom: 1rem;
        overflow: hidden;
        border: 1px solid rgba(226, 232, 240, 0.7);
        box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
    }

    .accordion-button {
        font-weight: 600;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.18) 0%, rgba(34, 197, 94, 0.18) 100%);
        color: #0f172a;
        padding: 1.1rem 1.25rem;
    }

    .accordion-button:not(.collapsed) {
        color: #1d4ed8;
        box-shadow: inset 0 -1px 0 rgba(226, 232, 240, 0.7);
    }

    .accordion-button:focus {
        box-shadow: 0 0 0 0.25rem rgba(37, 99, 235, 0.2);
    }

    .accordion-body {
        background: rgba(248, 250, 252, 0.75);
    }

    .btn-outline-primary svg,
    .btn-outline-danger svg {
        transition: transform 0.2s ease;
    }

    .btn-outline-primary:hover svg,
    .btn-outline-danger:hover svg {
        transform: scale(1.05);
    }

    .btn-pill {
        border-radius: 999px !important;
        width: 48px;
        height: 48px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        border: 1px solid rgba(226, 232, 240, 0.8);
        box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
    }

    .btn-pill:hover {
        background: linear-gradient(135deg, #2d3748 0%, #1e293b 100%);
        color: #f8fafc;
        border-color: transparent;
        box-shadow: 0 12px 28px rgba(15, 23, 42, 0.28);
    }

    .custom-table tbody tr:last-child td {
        border-bottom: none;
    }

    .table-wrapper::-webkit-scrollbar,
    .modal-xxl .modal-body::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    .table-wrapper::-webkit-scrollbar-track,
    .modal-xxl .modal-body::-webkit-scrollbar-track {
        background: rgba(241, 245, 249, 0.8);
        border-radius: 999px;
    }

    .table-wrapper::-webkit-scrollbar-thumb,
    .modal-xxl .modal-body::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        border-radius: 999px;
    }

    .table-wrapper::-webkit-scrollbar-thumb:hover,
    .modal-xxl .modal-body::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #16a34a 100%);
    }

    /* Dark theme adjustments */
    [data-bs-theme="dark"] .modal-matriz-content {
        background: linear-gradient(135deg, #101828 0%, #1c2333 100%);
        border: 1px solid rgba(71, 85, 105, 0.45);
    }

    [data-bs-theme="dark"] .modal-xxl .modal-content {
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .title {
        -webkit-text-fill-color: currentColor;
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .title i {
        color: #38bdf8;
    }

    [data-bs-theme="dark"] .card-matriz {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.92) 0%, rgba(30, 41, 59, 0.95) 100%);
        border: 1px solid rgba(71, 85, 105, 0.55);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.45);
    }

    [data-bs-theme="dark"] .card-matriz > .nav-tabs {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%);
        border-color: rgba(71, 85, 105, 0.55);
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link {
        background: rgba(30, 41, 59, 0.85);
        color: #cbd5f5;
        box-shadow: inset 0 0 0 1px rgba(71, 85, 105, 0.5);
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link:hover {
        background: rgba(59, 130, 246, 0.25);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .btn-success {
        background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
        box-shadow: 0 12px 32px rgba(22, 163, 74, 0.4);
    }

    [data-bs-theme="dark"] .btn-outline-success {
        border-color: rgba(34, 197, 94, 0.6);
        color: #6ee7b7;
    }

    [data-bs-theme="dark"] .btn-outline-success:hover {
        background: rgba(34, 197, 94, 0.15);
    }

    [data-bs-theme="dark"] .btn-outline-primary {
        border-color: rgba(59, 130, 246, 0.6);
        color: #93c5fd;
        background: rgba(37, 99, 235, 0.15);
    }

    [data-bs-theme="dark"] .btn-outline-primary:hover {
        background: rgba(59, 130, 246, 0.25);
        color: #bfdbfe;
    }

    [data-bs-theme="dark"] .btn-outline-danger {
        border-color: rgba(248, 113, 113, 0.6);
        color: #fca5a5;
        background: rgba(248, 113, 113, 0.12);
    }

    [data-bs-theme="dark"] .btn-outline-danger:hover {
        background: rgba(248, 113, 113, 0.2);
        color: #fecaca;
    }

    [data-bs-theme="dark"] .custom-table {
        background: rgba(15, 23, 42, 0.95);
    }

    [data-bs-theme="dark"] .custom-table thead {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(34, 197, 94, 0.16) 100%);
    }

    [data-bs-theme="dark"] .custom-table th,
    [data-bs-theme="dark"] .custom-table td {
        color: #e2e8f0;
        border-bottom: 1px solid rgba(71, 85, 105, 0.6);
    }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.2);
    }

    [data-bs-theme="dark"] .accordion-item {
        border-color: rgba(71, 85, 105, 0.6);
        background: rgba(15, 23, 42, 0.9);
        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);
    }

    [data-bs-theme="dark"] .accordion-button {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.2) 0%, rgba(34, 197, 94, 0.2) 100%);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .accordion-body {
        background: rgba(15, 23, 42, 0.75);
    }

    [data-bs-theme="dark"] .table-wrapper {
        box-shadow: inset 0 0 0 1px rgba(71, 85, 105, 0.65);
    }

    [data-bs-theme="dark"] hr {
        background: linear-gradient(90deg, rgba(59, 130, 246, 0), rgba(59, 130, 246, 0.4), rgba(59, 130, 246, 0));
    }

    [data-bs-theme="dark"] .btn-pill {
        background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        border: 1px solid rgba(71, 85, 105, 0.7);
        box-shadow: 0 10px 26px rgba(0, 0, 0, 0.45);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-pill:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        border-color: transparent;
        box-shadow: 0 14px 32px rgba(239, 68, 68, 0.4);
    }

    [data-bs-theme="dark"] .modal-xxl .modal-body::-webkit-scrollbar-thumb,
    [data-bs-theme="dark"] .table-wrapper::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] .modal-xxl .modal-body::-webkit-scrollbar-track,
    [data-bs-theme="dark"] .table-wrapper::-webkit-scrollbar-track {
        background: rgba(15, 23, 42, 0.8);
    }

    [data-bs-theme="dark"] .modal-xxl .modal-body::-webkit-scrollbar-thumb:hover,
    [data-bs-theme="dark"] .table-wrapper::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #2563eb 0%, #059669 100%);
    }

    @media (max-width: 992px) {
        .card-matriz {
            padding: 1.25rem;
            gap: 1.25rem;
        }

        .card-matriz > .nav-tabs {
            margin: -1.25rem -1.25rem 0;
            padding: 1rem 1.25rem 0.35rem;
        }
    }

    @media (max-width: 768px) {
        .nav-tabs {
            gap: 0.35rem;
        }

        .nav-tabs .nav-link {
            padding: 0.55rem 1rem;
        }
    }

    @media (max-width: 576px) {
        .card-matriz {
            padding: 1rem;
            border-radius: 16px;
        }

        .table-wrapper {
            box-shadow: none;
        }

        .card-matriz > .nav-tabs {
            margin: -1rem -1rem 0;
            padding: 0.9rem 1rem 0.25rem;
        }

        
    }
</style>

